import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { Chip, PageHead, Pager, Table, Tabs, when } from "./kit";

const cell = { width: "100%", padding: "6px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

/// Cihaz ve IP yasagi: engellenen kisi yeni hesap acip geri donemesin.
const Bans = () => {
  const [tab, setTab] = useState("liste");
  const [rows, setRows] = useState({ data: [], total: 0 });
  const [page, setPage] = useState(1);
  const [kind, setKind] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  // hesaptan yasaklama
  const [userId, setUserId] = useState("");
  const [info, setInfo] = useState(null);
  const [reason, setReason] = useState("");
  const [days, setDays] = useState(0);
  const [birim, setBirim] = useState("gun");
  const sure = () => (Number(days) || 0) / (birim === "saat" ? 24 : 1);
  const [banIp, setBanIp] = useState(true);
  const [busy, setBusy] = useState(false);

  // elle ekleme
  const [mKind, setMKind] = useState("ip");
  const [mValue, setMValue] = useState("");
  const [mReason, setMReason] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.bans({ start: page, limit: 25, kind, search });
    if (r?.status) setRows(r);
    setLoading(false);
  }, [page, kind, search]);

  useEffect(() => {
    if (tab === "liste") load();
  }, [tab, load]);

  const lookup = async () => {
    setInfo(null);
    if (!userId.trim()) return;
    setBusy(true);
    const r = await api.banUserInfo(userId.trim());
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Bulunamadı");
    setInfo(r);
  };

  const doBanUser = async () => {
    if (!window.confirm("Bu hesap engellenecek, cihazı ve IP'si yasaklanacak. Onaylıyor musun?")) return;
    setBusy(true);
    const r = await api.banUser({ userId: userId.trim(), reason, days: sure(), banIp });
    setBusy(false);
    window.alert(r?.message || "Bitti");
    if (r?.status) {
      setInfo(null);
      setUserId("");
      setTab("liste");
    }
  };

  const doAdd = async () => {
    if (!mValue.trim()) return window.alert("Değer gerekli");
    setBusy(true);
    const r = await api.banAdd({ kind: mKind, value: mValue.trim(), reason: mReason, days: sure() });
    setBusy(false);
    window.alert(r?.message || "Bitti");
    if (r?.status) {
      setMValue("");
      setMReason("");
      setTab("liste");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Yasak kaldırılsın mı?")) return;
    const r = await api.banRemove(id);
    if (!r?.status) return window.alert(r?.message || "Olmadı");
    load();
  };

  return (
    <>
      <PageHead
        title="Cihaz / IP Yasağı"
        sub="Engellenen kişi uygulamayı silip yeniden kursa da giremez. IP yasağı aynı bağlantıyı paylaşan herkesi etkiler — dikkatli kullan."
      />

      <Tabs
        tabs={[
          ["liste", "Yasak listesi"],
          ["hesap", "Hesaptan yasakla"],
          ["elle", "Elle ekle"],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === "liste" && (
        <>
          <div className="d-flex" style={{ gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
            <select style={{ ...cell, width: 160 }} value={kind} onChange={(e) => { setPage(1); setKind(e.target.value); }}>
              <option value="">Hepsi</option>
              <option value="device">Cihaz</option>
              <option value="ip">IP</option>
            </select>
            <input
              style={{ ...cell, width: 240 }}
              placeholder="Ara (cihaz kimliği / IP)"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && (setPage(1), load())}
            />
            <button className="btn btn-sm btn-outline-secondary" onClick={() => { setPage(1); load(); }}>
              Ara
            </button>
          </div>

          <Table
            head={["Tür", "Değer", "Hesap", "Sebep", "Bitiş", "Tarih", ""]}
            loading={loading}
            empty="Yasaklı cihaz veya IP yok."
            rows={rows.data.map((b) => (
              <tr key={b._id}>
                <td>{b.kind === "device" ? <Chip kind="wait">Cihaz</Chip> : <Chip kind="info">IP</Chip>}</td>
                <td style={{ fontFamily: "monospace", fontSize: 12 }}>{b.value}</td>
                <td>
                  {b.userName || "—"}
                  {b.uniqueID ? <div style={small}>ID {b.uniqueID}</div> : null}
                </td>
                <td style={small}>{b.reason || "—"}</td>
                <td style={small}>{b.expiresAt ? when(b.expiresAt) : "Kalıcı"}</td>
                <td style={small}>{when(b.createdAt)}</td>
                <td>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => remove(b._id)}>
                    Kaldır
                  </button>
                </td>
              </tr>
            ))}
          />
          <Pager page={page} size={25} total={rows.total} onChange={setPage} />
        </>
      )}

      {tab === "hesap" && (
        <div className="card">
          <div className="card-body" style={{ maxWidth: 620 }}>
            <p style={small}>
              Kullanıcı kimliğini (Kullanıcılar sayfasındaki uzun ID) yapıştır. Hesabın son kullandığı cihaz ve IP
              yasaklanır, hesap da engellenir.
            </p>
            <div className="d-flex" style={{ gap: 8, marginBottom: 12 }}>
              <input style={cell} placeholder="Kullanıcı ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
              <button className="btn btn-sm btn-outline-secondary" disabled={busy} onClick={lookup}>
                Getir
              </button>
            </div>

            {info && (
              <div style={{ border: "1px solid #E5E7EB", borderRadius: 8, padding: 12, marginBottom: 12 }}>
                <b>{info.user.name}</b> <span style={small}>ID {info.user.uniqueID}</span>
                <div style={small}>Cihaz: {info.user.lastDeviceId || "kayıt yok"}</div>
                <div style={small}>IP: {info.user.lastIp || "kayıt yok"}</div>
                <div style={small}>Son görülme: {when(info.user.lastSeenAt)}</div>
                {info.siblings?.length ? (
                  <div style={{ marginTop: 8 }}>
                    <b style={{ fontSize: 13 }}>Aynı cihazdaki diğer hesaplar ({info.siblings.length})</b>
                    <div style={small}>{info.siblings.map((s) => `${s.name} (${s.uniqueID})`).join(", ")}</div>
                  </div>
                ) : null}
              </div>
            )}

            <input style={{ ...cell, marginBottom: 8 }} placeholder="Sebep" value={reason} onChange={(e) => setReason(e.target.value)} />
            <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 12 }}>
              <span style={small}>Süre (0 = kalıcı)</span>
              <input style={{ ...cell, width: 100 }} type="number" value={days} onChange={(e) => setDays(e.target.value)} />
              <select style={{ ...cell, width: 90 }} value={birim} onChange={(e) => setBirim(e.target.value)}>
                <option value="saat">Saat</option>
                <option value="gun">Gün</option>
              </select>
              <label style={{ ...small, display: "flex", alignItems: "center", gap: 6, margin: 0 }}>
                <input type="checkbox" checked={banIp} onChange={(e) => setBanIp(e.target.checked)} /> IP'yi de yasakla
              </label>
            </div>
            <button className="btn btn-danger" disabled={busy || !userId.trim()} onClick={doBanUser}>
              Yasakla
            </button>
          </div>
        </div>
      )}

      {tab === "elle" && (
        <div className="card">
          <div className="card-body" style={{ maxWidth: 520 }}>
            <select style={{ ...cell, marginBottom: 8 }} value={mKind} onChange={(e) => setMKind(e.target.value)}>
              <option value="ip">IP adresi</option>
              <option value="device">Cihaz kimliği</option>
            </select>
            <input style={{ ...cell, marginBottom: 8 }} placeholder={mKind === "ip" ? "ör. 85.104.12.7" : "ör. a:9fd2..."} value={mValue} onChange={(e) => setMValue(e.target.value)} />
            <input style={{ ...cell, marginBottom: 8 }} placeholder="Sebep" value={mReason} onChange={(e) => setMReason(e.target.value)} />
            <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 12 }}>
              <span style={small}>Süre (0 = kalıcı)</span>
              <input style={{ ...cell, width: 100 }} type="number" value={days} onChange={(e) => setDays(e.target.value)} />
              <select style={{ ...cell, width: 90 }} value={birim} onChange={(e) => setBirim(e.target.value)}>
                <option value="saat">Saat</option>
                <option value="gun">Gün</option>
              </select>
            </div>
            <button className="btn btn-danger" disabled={busy} onClick={doAdd}>
              Ekle
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Bans;
